function parseSassStyles() {
  const sheets = Array.from(
    document.querySelectorAll('style[compiler="sass"]'),
  );
  sheets.forEach((sheet) => {
    Sass.compile(sheet.innerHTML, (result) => {
      sheet.innerHTML = result.text;
    });
  });
}

window.addEventListener("DOMContentLoaded", parseSassStyles);
